var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEckoWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_112679",
    "data-name": "Group 112679",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 241.6,
    height: 32,
    viewBox: "0 0 241.6 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-wallet-header",
    x1: -0.203,
    y1: -0.134,
    x2: 0.9,
    y2: 0.1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77852-2",
    "data-name": "Group 77852-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74956",
    "data-name": "Path 74956",
    d: "M3328.521-2397.064a11.339,11.339,0,0,0-11.707,11.733c0,6.685,4.813,11.655,11.828,11.655,4.814,0,9.3-2.324,10.973-7.621h-6.038a5.184,5.184,0,0,1-4.976,2.812,5.557,5.557,0,0,1-5.832-5.378h17.213C3340.552-2391.237,3335.944-2397.064,3328.521-2397.064Zm-5.467,8.924a5.435,5.435,0,0,1,5.427-4.119,5.223,5.223,0,0,1,5.3,4.119Z",
    transform: "translate(-3316.814 2405.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74957",
    "data-name": "Path 74957",
    d: "M3414.05-2379.054c-3.428,0-5.794-2.566-5.754-6.317-.04-3.708,2.245-6.314,5.794-6.314a5.054,5.054,0,0,1,5.179,3.627h6c-.856-5.705-5.711-9-11.176-9a11.4,11.4,0,0,0-11.707,11.692,11.393,11.393,0,0,0,11.667,11.7c5.384,0,10.319-3.139,11.216-9.046h-6A5.1,5.1,0,0,1,3414.05-2379.054Z",
    transform: "translate(-3377.629 2405.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74958",
    "data-name": "Path 74958",
    d: "M3531.915-2339.127h-7.466l-7.366-8.659h7.521Z",
    transform: "translate(-3459.147 2370.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74959",
    "data-name": "Path 74959",
    d: "M3509.437-2417.43l-10.238,10.676-3.9,3.886-1.812,1.807v6.043h-5.834v-31.376h5.834v18.3l8.526-9.331Z",
    transform: "translate(-3438.232 2426.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74960",
    "data-name": "Path 74960",
    d: "M3570.228-2397.064a11.488,11.488,0,0,0-11.665,11.692,11.463,11.463,0,0,0,11.665,11.7,11.45,11.45,0,0,0,11.708-11.7A11.5,11.5,0,0,0,3570.228-2397.064Zm0,17.848c-3.264,0-5.792-2.448-5.792-6.156,0-3.667,2.528-6.153,5.792-6.153s5.794,2.485,5.794,6.153c0,3.708-2.532,6.156-5.794,6.156Z",
    transform: "translate(-3488.627 2405.541)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Group_77896",
    "data-name": "Group 77896",
    d: "M3681.242-2413.4h7.047l-6.845,28.1h-8.465l-2.469-10.158-1.459-9.917-.688-.04-1.417,9.957-2.471,10.158h-8.5l-6.845-28.1h7.087l3.241,13.449.85,6.545.851-6.545,3.241-13.449h8.625l3.241,13.449.891,6.7.851-6.7Zm39.279,21.6h11.5v6.5h-18.387v-28.1h6.884Zm19.747,0h11.5v6.5h-18.387v-28.1h6.885Zm54.322-21.6v6.5h-7.736v21.6h-6.885v-21.6h-7.695v-6.5Zm-89.906,28.243-1.577-4.734h-10.2l-1.578,4.734h-7.364l9.874-28.243h8.418l9.833,28.243Zm-10.035-9.95h6.717l-3.359-10.03Zm76-11.72H3760.31v4.176h9.126v6.5h-9.126v4.416h10.344v6.5h-17.229v-28.1h17.229Z",
    transform: "translate(-3552.991 2417.153)",
    fill: "url(#linear-gradient-wallet-header)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoWallet);
export default __webpack_public_path__ + "static/media/eckoWALLET.2f6caef7e58ef499009f441bd3d27699.svg";
export { ForwardRef as ReactComponent };